import { render, staticRenderFns } from "./ModalIncompatibleItem.vue?vue&type=template&id=23ed36fc&scoped=true"
import script from "./ModalIncompatibleItem.vue?vue&type=script&lang=js"
export * from "./ModalIncompatibleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed36fc",
  null
  
)

export default component.exports